import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import assert from 'assert';
import { Store } from 'libx';
import memoize from 'memoizee';
import { concatMap, filter, map, share } from 'rxjs/operators';
import { collection } from '../../utils/collection';
import { filterNonNil } from '../../utils/rxUtil';
import { Call } from './Call';
var CallStore = /*#__PURE__*/function (_Store) {
  function CallStore() {
    var _this;
    _classCallCheck(this, CallStore);
    _this = _callSuper(this, CallStore, arguments);
    _this.calls = collection({
      create: function create(attrs) {
        return new Call(_this.rootStore.messageStore.primeConversation({
          id: attrs.conversation_id
        }), _this.rootStore.memberStore.setAndFetch.bind(_this.rootStore.memberStore), _this.rootStore.getTime.bind(_this.rootStore), _this.events$);
      }
    });
    assert(_this.rootStore, 'no rootStore passed to MessageStore');
    assert(_this.rootStore.userStore, 'rootStore needs a userStore');
    assert(_this.rootStore.authStore, 'rootStore needs an authStore');
    assert(_this.rootStore.authStore.token$, 'authStore needs a token$ observable');
    assert(_this.rootStore.getTime, 'rootStore needs a getTime');
    var messagingAPI = _this.rootStore.messagingAPI;
    _this.api = messagingAPI.calls;
    _this.events$ = messagingAPI.events$.pipe(
    // Ensures events are processed serially.
    concatMap(_this.handleEvent.bind(_this)), filterNonNil(), share());
    _this.incomingCall$ = _this.events$.pipe(filter(function (e) {
      return e.type === 'ParticipantInvited' && e.participant.member.isCurrentUser;
    }), map(function (e) {
      return e.call;
    }), share());
    _this.fetchCall = memoize(_this.fetchCall.bind(_this), {
      length: 1,
      promise: true
    });
    _this.events$.subscribe();
    _this.joinCall = _this.joinCall.bind(_this);
    return _this;
  }

  /**
   * Convenience method for getting currently
   * logged in user
   * @returns
   */
  _inherits(CallStore, _Store);
  return _createClass(CallStore, [{
    key: "getCurrentUser",
    value: function getCurrentUser() {
      return this.rootStore.sessionStore.user;
    }

    /**
     * Fetches a call by ID.
     * @param callId
     * Memoized
     */
  }, {
    key: "fetchCall",
    value: (function () {
      var _fetchCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(callId) {
        var callDto;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.api.get(callId);
            case 2:
              callDto = _context.sent;
              return _context.abrupt("return", this.setCallAsync(callId, callDto));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCall(_x) {
        return _fetchCall.apply(this, arguments);
      }
      return fetchCall;
    }()
    /**
     * Join the call.
     *
     * @param {Call} call
     */
    )
  }, {
    key: "joinCall",
    value: (function () {
      var _joinCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(call) {
        var _yield$this$api$join, connectionDescriptor, currentUser;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.api.join(call.id);
            case 2:
              _yield$this$api$join = _context2.sent;
              connectionDescriptor = _yield$this$api$join.call_connection_descriptor;
              currentUser = this.getCurrentUser();
              call.ensureParticipant(currentUser.id, currentUser.public_id);
              return _context2.abrupt("return", {
                call: call,
                connectionDescriptor: connectionDescriptor
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function joinCall(_x2) {
        return _joinCall.apply(this, arguments);
      }
      return joinCall;
    }())
  }, {
    key: "startCall",
    value: function () {
      var _startCall = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(conversation, participants) {
        var _yield$this$api$start, callDto, connectionDescriptor, call;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              participants = participants.filter(function (p) {
                return p.member.isCurrentUser === false;
              });
              _context3.next = 3;
              return this.api.startOrJoin({
                conversation_id: conversation.id,
                invitee_identities: participants.map(function (p) {
                  return {
                    user_id: p.member.userId,
                    user_public_id: p.member.userPublicId
                  };
                })
              });
            case 3:
              _yield$this$api$start = _context3.sent;
              callDto = _yield$this$api$start.call;
              connectionDescriptor = _yield$this$api$start.call_connection_descriptor;
              _context3.next = 8;
              return this.setCallAsync(callDto.id, callDto);
            case 8:
              call = _context3.sent;
              return _context3.abrupt("return", {
                call: call,
                connectionDescriptor: connectionDescriptor
              });
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function startCall(_x3, _x4) {
        return _startCall.apply(this, arguments);
      }
      return startCall;
    }()
    /**
     * Hang up the call.
     *
     * @param {Call} call
     */
  }, {
    key: "hangup",
    value: (function () {
      var _hangup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(call) {
        var currentUser, currentUserCallParticipant;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              currentUser = this.getCurrentUser();
              currentUserCallParticipant = call.participants.get(currentUser.id);
              if (currentUserCallParticipant) {
                currentUserCallParticipant.markDisconnected();
              }
              _context4.next = 5;
              return this.api.hangup(call.id);
            case 5:
              return _context4.abrupt("return", call);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function hangup(_x5) {
        return _hangup.apply(this, arguments);
      }
      return hangup;
    }()
    /**
     * Declines the call.
     *
     * @param {Call} call
     */
    )
  }, {
    key: "decline",
    value: (function () {
      var _decline = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(call) {
        var currentUser, currentUserCallParticipant;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              currentUser = this.getCurrentUser();
              currentUserCallParticipant = call.participants.get(currentUser.id);
              if (currentUserCallParticipant) {
                currentUserCallParticipant.markDeclined();
              }
              _context5.next = 5;
              return this.api.decline(call.id);
            case 5:
              return _context5.abrupt("return", call);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function decline(_x6) {
        return _decline.apply(this, arguments);
      }
      return decline;
    }()
    /**
     * Primes a call synchronously, fetches it in the background
     *
     * @param {Conversation} conversation
     * @param {*} props
     * @returns {Call}
     */
    )
  }, {
    key: "primeCall",
    value: function primeCall(props) {
      if (!props || !props.id || !props.conversation_id) {
        return undefined;
      }
      var convo = this.rootStore.messageStore.primeConversation({
        id: props.conversation_id
      });
      this.fetchCall(props.id).then();
      var call = this.calls.set({
        id: props.id,
        conversation_id: convo.id
      });

      // The call was already hydrated from the server, so don't
      // asssign any props to it
      if (call.dateCreated > new Date(0)) {
        return call;
      }
      return call.set(props, {
        stripUndefined: true,
        parse: true
      });
    }

    /**
     * Sets the Call state from a DTO. Ensures
     * that all necessary info is loaded prior,
     *
     * @param callId
     * @param callDto
     * @private
     */
  }, {
    key: "setCallAsync",
    value: (function () {
      var _setCallAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(callId, callDto) {
        var call;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              call = this.calls.get(callId);
              if (!(!call && callDto.conversation_id)) {
                _context6.next = 5;
                break;
              }
              console.log("Call wasn't found, fetching convo", callId, callDto);
              // If the call isn't in memory, load the convo.
              // On the other hand, if we already had it then we already
              // loaded the convo.
              _context6.next = 5;
              return this.rootStore.messageStore.fetchConversation(callDto.conversation_id);
            case 5:
              return _context6.abrupt("return", this.calls.set(_objectSpread(_objectSpread({}, callDto), {}, {
                id: callId
              })));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setCallAsync(_x7, _x8) {
        return _setCallAsync.apply(this, arguments);
      }
      return setCallAsync;
    }())
  }, {
    key: "handleEvent",
    value: function () {
      var _handleEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(event) {
        var call, _call, participant, _call2, _participant, _call3, _participant2, _call4, _participant3, _call5, _participant4, _call6, _participant5, _call7;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = event.type;
              _context7.next = _context7.t0 === 'CALL_STARTED' ? 3 : _context7.t0 === 'CALL_PARTICIPANT_INVITED' ? 7 : _context7.t0 === 'CALL_PARTICIPANT_JOINED' ? 12 : _context7.t0 === 'CALL_PARTICIPANT_DECLINED' ? 17 : _context7.t0 === 'CALL_PARTICIPANT_CONNECTED' ? 23 : _context7.t0 === 'CALL_PARTICIPANT_DISCONNECTED' ? 29 : _context7.t0 === 'CALL_PARTICIPANT_MISSED' ? 35 : _context7.t0 === 'CALL_COMPLETED' ? 41 : 45;
              break;
            case 3:
              _context7.next = 5;
              return this.setCallAsync(event.payload.id, event.payload);
            case 5:
              call = _context7.sent;
              return _context7.abrupt("return", {
                type: 'CallStarted',
                call: call
              });
            case 7:
              _context7.next = 9;
              return this.fetchCall(event.payload.id);
            case 9:
              _call = _context7.sent;
              participant = _call.ensureParticipant(event.payload.participant_user_id, event.payload.participant_public_user_id);
              return _context7.abrupt("return", {
                call: _call,
                participant: participant,
                type: 'ParticipantInvited'
              });
            case 12:
              _context7.next = 14;
              return this.fetchCall(event.payload.id);
            case 14:
              _call2 = _context7.sent;
              _participant = _call2.ensureParticipant(event.payload.participant_user_id, event.payload.participant_public_user_id);
              return _context7.abrupt("return", {
                call: _call2,
                participant: _participant,
                type: 'ParticipantJoined'
              });
            case 17:
              _context7.next = 19;
              return this.fetchCall(event.payload.id);
            case 19:
              _call3 = _context7.sent;
              _participant2 = _call3.ensureParticipant(event.payload.participant_user_id, event.payload.participant_public_user_id);
              _participant2.markDeclined();
              return _context7.abrupt("return", {
                call: _call3,
                participant: _participant2,
                type: 'ParticipantDeclined'
              });
            case 23:
              _context7.next = 25;
              return this.fetchCall(event.payload.id);
            case 25:
              _call4 = _context7.sent;
              _participant3 = _call4.ensureParticipant(event.payload.participant_user_id, event.payload.participant_public_user_id);
              _participant3.markConnected();
              return _context7.abrupt("return", {
                call: _call4,
                participant: _participant3,
                type: 'ParticipantConnected'
              });
            case 29:
              _context7.next = 31;
              return this.fetchCall(event.payload.id);
            case 31:
              _call5 = _context7.sent;
              _participant4 = _call5.ensureParticipant(event.payload.participant_user_id, event.payload.participant_public_user_id);
              _participant4.markDisconnected();
              return _context7.abrupt("return", {
                call: _call5,
                participant: _participant4,
                type: 'ParticipantDisconnected'
              });
            case 35:
              _context7.next = 37;
              return this.fetchCall(event.payload.id);
            case 37:
              _call6 = _context7.sent;
              _participant5 = _call6.ensureParticipant(event.payload.participant_user_id, event.payload.participant_public_user_id);
              _participant5.markMissed();
              return _context7.abrupt("return", {
                call: _call6,
                participant: _participant5,
                type: 'ParticipantMissedCall'
              });
            case 41:
              _context7.next = 43;
              return this.setCallAsync(event.payload.id, {
                call_status: 'COMPLETED',
                date_completed: event.payload.date_completed
              });
            case 43:
              _call7 = _context7.sent;
              return _context7.abrupt("return", {
                call: _call7,
                type: 'CallCompleted'
              });
            case 45:
              return _context7.abrupt("return", null);
            case 46:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleEvent(_x9) {
        return _handleEvent.apply(this, arguments);
      }
      return handleEvent;
    }()
  }]);
}(Store);
export { CallStore as default };
//# sourceMappingURL=CallStore.js.map
